import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { DEFAULT_LANGUAGE } from "./lib/i18n";
import "./styles/global.css";

try {
  document.documentElement.lang = localStorage.getItem("ym_language") || DEFAULT_LANGUAGE;
  document.documentElement.dataset.theme = localStorage.getItem("ym_theme") || "dark";
} catch {
  document.documentElement.lang = DEFAULT_LANGUAGE;
  document.documentElement.dataset.theme = "dark";
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
